/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_CopiedInputs */

const en_road_dude_prompt_copied = /** @type {(inputs: Road_Dude_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const zh_road_dude_prompt_copied = /** @type {(inputs: Road_Dude_Prompt_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Road_Dude_Prompt_CopiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_copied = /** @type {((inputs?: Road_Dude_Prompt_CopiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_CopiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_copied(inputs)
	return zh_road_dude_prompt_copied(inputs)
});
export { road_dude_prompt_copied as "road_dude.prompt.copied" }